import React, { useEffect, useRef, useState } from "react"
import ReactCrop, { Crop, ReactCropProps } from "react-image-crop"
import { getBase64 } from "utils/file.utils"
interface ImageCropperProps extends ReactCropProps {
  img: string | File
  onCrop: (file: File) => void
}
const ImageCropper = ({ crop, img, onCrop }: ImageCropperProps) => {
  const imageRef = useRef<any>()
  const [currentCrop, setCrop] = useState<Crop | undefined>(crop)
  const [image, setImage] = useState("")
  const [imgObject, setImageObject] = useState<File | undefined>()
  useEffect(() => {
    if (img instanceof File) {
      getBase64(img, (data: any) => {
        setImage(data)
        setImageObject(img)
      })
    } else {
      setImage(img)
    }
  }, [img])

  return (
    <ReactCrop
      onImageLoaded={img => {
        imageRef.current = img
      }}
      src={image}
      crop={currentCrop}
      onChange={(crop: any) => setCrop(crop)}
      ruleOfThirds
      onComplete={(crop: any) => {
        const image = imageRef.current

        if (image && crop.width && crop.height && imgObject) {
          const canvas = document.createElement("canvas")
          const scaleX = image.naturalWidth / image.width
          const scaleY = image.naturalHeight / image.height
          canvas.width = crop.width
          canvas.height = crop.height
          const ctx: any = canvas.getContext("2d")

          ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
          )

          try {
            canvas.toBlob((blob: any) => {
              const file = new File([blob], imgObject?.name ?? "", imgObject)
              onCrop(file)
            })
          } catch (err) {}
        }
      }}
    />
  )
}

ImageCropper.defaultProps = {
  crop: { unit: "%", aspect: 1, width: 100 },
}
export default ImageCropper
